import { SingleSelectDropdown, SingleSelectDropdownProps } from 'ck-components';
import {
  TargetGroupEnum,
  translateTargetGroup,
  useQueryTargetGroups,
} from 'ck-queries';

import { FieldValues } from 'react-hook-form';
import { useMemo } from 'react';

type Props<T extends FieldValues, K> = Omit<
  SingleSelectDropdownProps<T, K>,
  | 'label'
  | 'defaultValue'
  | 'values'
  | 'labelFromValue'
  | 'onChange'
  | 'controlledConfig'
  | 'onChangeEffect'
  | 'hideValues'
>;

/**
 * DropdownSelector to pick a label-value pair.
 * Needs more work before fully generalized.
 */
export const TargetGroupDropdownSelector = <T extends FieldValues, K>(
  props: Props<T, K>
) => {
  const Q_targetGroups = useQueryTargetGroups();
  const defaultTarget = useMemo(() => {
    if (Q_targetGroups.data) {
      if (Q_targetGroups.data[0].group === '') return TargetGroupEnum.All;
      return Q_targetGroups.data[0].group;
    }
    return TargetGroupEnum.All;
  }, [Q_targetGroups.data]);

  return (
    <SingleSelectDropdown
      {...props}
      label='VISAS FÖR'
      disabled={
        !Q_targetGroups.data ||
        Q_targetGroups.data.length < 1 ||
        Q_targetGroups.isLoading
      }
      defaultValue={defaultTarget}
      emptyStateLabel={'Välj målgrupp'}
      values={
        Q_targetGroups.data
          ? Q_targetGroups.data
              .map((tg) => tg.group)
              .filter((group): group is TargetGroupEnum =>
                Object.values(TargetGroupEnum).includes(
                  group as TargetGroupEnum
                )
              )
          : ([] as TargetGroupEnum[])
      }
      labelFromValue={(value: TargetGroupEnum) => translateTargetGroup(value)}
    />
  );
};
